module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-header'), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticClass: "device-list"
  }, [_vm._l((_vm.deviceList), function(item, index) {
    return _c('div', {
      key: item.device_id.$oid,
      staticClass: "device-item",
      on: {
        "click": function($event) {
          _vm.intoDevice(index)
        }
      }
    }, [_c('el-card', {
      staticClass: "box-card"
    }, [_c('div', {
      staticClass: "clearfix card-heard"
    }, [_c('span', {
      staticStyle: {
        "line-height": "36px"
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "device-info"
    }, [_c('div', [_c('p', [_c('span', {
      staticClass: "s-label"
    }, [_vm._v("DTU号")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.device_sn))])]), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "s-label"
    }, [_vm._v("状态 ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.device_status))])]), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "s-label"
    }, [_vm._v("类型 ")]), _vm._v(" "), _c('span', [(item.category === '温控') ? _c('el-tag', {
      attrs: {
        "type": "danger"
      }
    }, [_vm._v(_vm._s(item.category))]) : _vm._e(), _vm._v(" "), (item.category === '配煤') ? _c('el-tag', {
      attrs: {
        "type": "info"
      }
    }, [_vm._v(_vm._s(item.category))]) : _vm._e(), _vm._v(" "), (item.category === '配水') ? _c('el-tag', [_vm._v(_vm._s(item.category))]) : _vm._e()], 1)])]), _vm._v(" "), _c('img', {
      attrs: {
        "src": _vm.image1,
        "alt": ""
      }
    })])])], 1)
  }), _vm._v(" "), (_vm.deviceList && _vm.deviceList.length) ? _c('div', {
    staticClass: "device-item"
  }, [_c('div', {
    staticClass: "add-new-device",
    on: {
      "click": function($event) {
        _vm.openBindDevice('device')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-dms-add_dashed"
  }), _vm._v(" "), _c('p', [_vm._v("添加新设备")])])]) : _vm._e()], 2), _vm._v(" "), (!_vm.loading && _vm.deviceList.length <= 0) ? _c('div', {
    staticClass: "no-device"
  }, [_c('img', {
    attrs: {
      "src": _vm.img_no_devices,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "noItem-button-group"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.openBindDevice('device')
      }
    }
  }, [_vm._v("绑定设备")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.openBindDevice('account')
      }
    }
  }, [_vm._v("绑定已有账号")])], 1)]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": _vm.isMobile ? "large" : "small",
      "title": _vm.dialog.method === 'account' ? '绑定账号' : '添加设备',
      "visible": _vm.dialog.show
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog.show = $event
      }
    }
  }, [_c('el-form', {
    ref: "dialog",
    attrs: {
      "model": _vm.dialog
    }
  }, [(_vm.dialog.method === 'account') ? _c('el-form-item', {
    attrs: {
      "label": "原平台账号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "services.leemma.com账号"
    },
    model: {
      value: (_vm.dialog.name),
      callback: function($$v) {
        _vm.dialog.name = $$v
      },
      expression: "dialog.name"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dialog.adminShow),
      expression: "dialog.adminShow"
    }],
    staticClass: "input-tips"
  }, [_vm._v("利马管理人员请登录"), _c('a', {
    attrs: {
      "href": "https://services.leemma.com"
    }
  }, [_vm._v("https://services.leemma.com")])])], 1) : _vm._e(), _vm._v(" "), (_vm.dialog.method === 'account') ? _c('el-form-item', {
    attrs: {
      "label": "密码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "services.leemma.com密码"
    },
    model: {
      value: (_vm.dialog.password),
      callback: function($$v) {
        _vm.dialog.password = $$v
      },
      expression: "dialog.password"
    }
  })], 1) : [_c('el-form-item', {
    attrs: {
      "label": "设备激活码"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.dialog.uuid),
      callback: function($$v) {
        _vm.dialog.uuid = $$v
      },
      expression: "dialog.uuid"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v("联系利马客服获取您的设备激活码 "), _c('a', {
    attrs: {
      "href": "tel:18030536882"
    }
  }, [_vm._v("18030536882(周星)")])])], 1)]], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [(_vm.dialog.method === 'account') ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.openBindDevice('device')
      }
    }
  }, [_vm._v("没有账号？绑定新设备")]) : _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.openBindDevice('account')
      }
    }
  }, [_vm._v("绑定已有账号")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.customerBinding
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24e80b0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/deviceList.vue
// module id = 901
// module chunks = 1